import axios from "../helpers/axiosFiles/axios";
import Cookies from "js-cookie"
//login register*********************************
export const RegisterForm = (params) => {
    return axios.post('/v1/user/register', params).then(res => {
        console.log(res);
        return res
    }).catch(error => {
        console.log(error.response);
        return error
    })
}
export const UserLogin = (params) => {
    return axios.post('/v1/user/login', params, { timeout: 30000 }).then(res => {
        return res
    }).catch(error => {
        return error.response
    })
}

export const forgetPassword = async (params) => {
    return axios.post('/v1/user/forget', params).then(res => {
        return res;
    }).catch(error => {
        console.log(error.response);
        return error;
    })
}
export const ResetPassword = (params) => {
    return axios.post('/v1/user/resetPassword', params).then(res => {
        return res
    }).catch(error => {
        console.log(error.response);
        return error
    })
}
export const VerifyCode = (params) => {
    return axios.post('/v1/user/validation', params).then(res => {
        return res
    }).catch(error => {
        console.log(error.response);
        return error
    })
}
//channels***************************************
export const GetChannelList = () => {
    return axios.get("v1/channel/channelList")
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err.response);
            return err
        })
}
export const GetSnappShopVendors = () => {
    return axios.get("v2/snappshop/vendors")
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err.response);
            return err
        })
}
export const SubmitDelete = (params, openToast) => {
    return axios
        .post("v1/channel/deleteChannel", params, { timeout: 30000 })
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err.response)
            openToast(err.response && err.response.data ? err.response.data.error : 'خطای سرور. لطفا با پشتیبانی تماس بگیرید. (۸۷۰۵ ۲۲۷ ۰۹۰۲)')
        })
}
export const SubmitAddChannel = (params, openToast) => {
    return axios.post(`v1/channel/addChannel`, params, { timeout: 30000 })
        .then(res => {
            return res
        })
        .catch(err => {
            openToast(err.response && err.response.data ? err.response.data.error : 'خطای سرور. لطفا با پشتیبانی تماس بگیرید. (۸۷۰۵ ۲۲۷ ۰۹۰۲)')
            return err
        })
}

export const SubmitChannelOTP = (params, openToast) => {
    return axios.post(`v1/channel/verifyChannel`, params, { timeout: 30000 })
        .then(res => {
            return res
        })
        .catch(err => {
            openToast(err.response && err.response.data ? err.response.data.error : 'خطای سرور. لطفا با پشتیبانی تماس بگیرید. (۸۷۰۵ ۲۲۷ ۰۹۰۲)')
            return err
        })
}
export const SubmitEditChannel = (params, openToast) => {
    return axios.post("/v1/channel/editChannelPassword", params, { timeout: 30000 })
        .then(res => {
            return res
        })
        .catch(err => {
            openToast(err.response && err.response.data ? err.response.data.error : 'خطای سرور. لطفا با پشتیبانی تماس بگیرید. (۸۷۰۵ ۲۲۷ ۰۹۰۲)')
            return err
        })
}
export const SubmitAddSnappShopChannel = (params, openToast) => {
    return axios.post("/v2/snappshop/auth/send-otp", params, { timeout: 30000 })
        .then(res => {
            return res
        })
        .catch(err => {
            openToast(err.response && err.response.data ? err.response.data.error : 'خطای سرور. لطفا با پشتیبانی تماس بگیرید. (۸۷۰۵ ۲۲۷ ۰۹۰۲)')
            return err
        })
}
export const SubmitSnappShopChannelOTP = (params, openToast) => {
    return axios.post(`/v2/snappshop/auth/otp-login`, params, { timeout: 30000 })
        .then(res => {
            return res
        })
        .catch(err => {
            openToast(err.response && err.response.data ? err.response.data.error : 'خطای سرور. لطفا با پشتیبانی تماس بگیرید. (۸۷۰۵ ۲۲۷ ۰۹۰۲)')
            return err
        })
}
export const SubmitSnappShopChannelPassword = (params, openToast) => {
    return axios.post(`/v2/snappshop/auth/user-pass-login`, params, { timeout: 30000 })
        .then(res => {
            return res
        })
        .catch(err => {
            openToast(err.response && err.response.data ? err.response.data.error : 'خطای سرور. لطفا با پشتیبانی تماس بگیرید. (۸۷۰۵ ۲۲۷ ۰۹۰۲)')
            return err
        })
}
export const ChannelCardToggle = (params) => {
    return axios.post("v1/channel/editActiveStatus", params)
        .then(res => {
            return res
        })
        .catch(err => err)
}

export const VendorCardToggle = (params) => {
    return axios.post("v2/snappshop/vendors/editActiveStatus", params)
        .then(res => {
            return res
        })
        .catch(err => err)
}
//products***************************************
export const GetList = (route, queryParams) => {
    return axios.get(route, { params: queryParams })
        .then(res => {
            return res.data;
        })
        .catch(error => {
            console.log(error);
            return error
        })
}
export const GetProductList = (queryParams) => {
    return axios.get("v1/product/list", { params: queryParams })
        .then(res => {
            return res;
        })
        .catch(error => {
            console.log(error);
            return error
        })
}
export const GetBrands = (openToast) => {
    return axios.get("v1/product/BrandList",
    )
        .then(res => {
            return res
        })
        .catch(error => {
            openToast(error.response.data.error)
            console.log(error.response)
        })
}
// GetErrors
export const GetErrors = (openToast) => {
    return axios.get("v1/pricing/errors",
    )
        .then(res => {
            return res
        })
        .catch(error => {
            openToast(error.response.data.error)
            console.log(error.response)
        })
}
export const GetproductGroup = (openToast) => {
    return axios.get("v1/product/groupList", {}).then(res => {
        return res
    }).catch(error => {
        openToast(error.response.data.error)
        console.log(error.response)
    })
}
export const GetSellers = (openToast) => {
    return axios.get("v1/channel/channelList").then(res => {
        return res
    }).catch(error => {
        openToast(error.response.data.error)
        console.log(error.response)
    })
}
export const EditProductName = (params) => {
    return axios.post("v1/product/editName", params)
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err.response);
            return err
        })
}
export const EditGroupProducts = (params) => {
    return axios.post("v1/product/unMerge", params)
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err.response);
            return err
        })
}
export const GroupProducts = (params) => {
    return axios.post("v1/product/merge", params)
        .then(res => {
            console.log(res, "res");
            return res
        })
        .catch(err => {
            console.log(err);
            return err
        })
}
export const DeleteGroupProducts = (params) => {
    return axios.post("v1/product/unMerge", params)
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err.response);
            return err
        })
}
//variant routes*****************************************************************
export const GetProductListFromDK = (params, openToast) => {
    return axios.post("v1/robot/getProductList", params)
        .then(res => {
            console.log(res, "dg");
            return res;

        })
        .catch(error => {
            openToast(error.response.data.error)
            console.log(error.response)
            return error.response;
        })

}
export const GetVariantList = (params, openToast) => {
    return axios.get("/v1/variant/list", { params })
        .then(res => {
            return res;
        })
        .catch(error => {
            if (error && error.response && error.response.data) {
                openToast(error.response.data.error)
            }
            console.log(error)
        })
}

export const GetSpecificPricingRangeVariant = (params) => {
    return axios.get("/v1/variant/specificPricingRange", { params })
        .then(res => {
            return res;
        })
        .catch(error => {
            if (error && error.response && error.response.data) {
                // openToast(error.response.data.error)
            }
            console.log(error)
        })
}
export const GetProgressbarData = (openToast) => {
    return axios.get("v1/variant/progressBar")
        .then(res => {
            // console.log(res,"hi");
            return res;
        })
        .catch(error => {
            openToast(error.response.data.error)
            console.log(error.response)
        })

}

export const GetSingleVariant = (id, openToast) => {
    return axios.get("v1/variant/variant", { params: { variantId: id } })
        .then(res => {
            return res.data.variant
        })
        .catch(error => {
            openToast(error.response.data.error)
            console.log(error.response)
        })
}
export const getManyVariant = (groups, openToast) => {
    return axios.get("v1/variant/getMany", { params: { productGroups: groups } })
        .then(res => {
            return res
        })
        .catch(error => {
            openToast(error.response.data.error)
            console.log(error.response)
        })
}
export const EditSingleVariantModalCalc = (data, openToast) => {
    return axios.post("v1/variant/edit", data)
        .then(res => {
            return true
        })
        .catch(err => {
            if (err && err.response && err.response.data.error) {
                openToast(err.response.data.error)
            } else {
                openToast('ویرایش با خطا مواجه شد')
            }
            console.log(err)
            return err
        })
}
export const EditMultipleVariantModalCalc = (data, openToast) => {
    return axios.post("v1/variant/editMany", data)
        .then(res => {
            return true
        })
        .catch(error => {
            openToast(error.response.data.error)
            console.log(error.response)
        })
}

export const ChangeSalesPrice = (data, openToast) => {
    return axios.post("v1/variant/changeSalesPrice", data)
        .then(res => {
            return true
        })
        .catch(error => {
            openToast('ویرایش با خطا مواجه شد')
            console.log(error.response)
        })
}

export const getPricingList = (data) => {
    return axios.get("v1/pricing/pricingList", { params: { ...data } })
        .then(res => {
            // console.log(res);
            // console.log(res.headers.disconnected);
            return res
        })
        .catch(err => console.log(err))
}

export const CalcPrice = (data, openToast) => {
    return axios.post("/v1/robot/calculatePrice", data, { timeout: 30000 })
        .then(res => {
            return res;
        })
        .catch(error => {
            openToast(error.response && error.response.data ? error.response.data.error : 'محاسبه قیمت با اختلال مواجه شد')
            return error;
        })
}

export const RepriceVariant = (data, openToast) => {
    return axios.post("/v1/variant/instantPricing", data, { timeout: 30000 })
        .then(res => {
            openToast('تنوع تا چند لحظه دیگر قیمت‌گذاری می‌شود', 'success')
            return res;
        })
        .catch(error => {
            openToast(error.response && error.response.data ? error.response.data.error : 'محاسبه قیمت با اختلال مواجه شد')
            return error;
        })
}

//users***************************************************
export const AddPermission = (params) => {
    return axios.post('v1/permission/add', params)
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err.response)
            return err
        })
}
export const EditPermission = (params) => {
    return axios.post('v1/permission/edit', params)
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err.response)
        })
}
export const DeletePermission = (params) => {
    return axios.post('v1/permission/delete', params)
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err.response)
            return err
        })
}
export const CheckDeletePermission = (params) => {
    return axios.post('v1/permission/delete/check', params)
        .then(res => {
            return res
        })
        .catch(err => {
            return err.response
        })
}

export const GetPermissionList = () => {
    return axios.get('v1/permission/permissionList')
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err.response)
        })
}
export const GetUsers = (params) => {
    return axios.get('v1/user/list', { params: params })
        .then(res => {
            console.log(res);
            return res
        })
        .catch(err => {
            console.log(err.response)
            return err
        })
}
export const AddUser = (params) => {
    return axios.post(`v1/user/add`, params)
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err);
            return err
        })
}
export const EditUser = (params) => {
    return axios.post(`v1/user/edit`, params)
        .then(res => {
            console.log(res);
            return res
        })
        .catch(err => {
            console.log(err);
            return err
        })
}
export const DeactiveUser = (params) => {
    return axios.post("/v1/user/deactive", params)
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err.response && err.response);
            return err
        })
}
export const DeleteUser = (params) => {
    return axios.post('/v1/user/delete', params)
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err.response)
            return err
        })
}
export const GetUser = () => {
    return axios.get('v1/user/get', { timeout: 30000 }, { headers: { token: Cookies.get('token') } })
        .then(res => {
            return res
        })
        .catch(err => {
            return err.response
        })
}
//profile*************************************************
export const EditProfile = (params) => {
    return axios.post('/v1/user/profile/edit', params)
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err.response)
        })
}
export const ProfileChangePassword = (params) => {
    return axios.post('/v1/user/profile/changepassword', params)
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err.response)
            return err
        })
}

// SnappShop*********************************************
export const SyncSnappShopVariants = () => {
    return axios.post(`/v2/snappshop/variations/sync`)
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err.response)
            return err
        })
}
export const GetSnappShopVariantList = (params) => {
    return axios.get(`/v2/snappshop/variations`, { params: params })
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err.response)
            return err
        })
}
export const EdiSnappShoptVariant = params => {
    return axios.post(`/v2/snappshop/variations/edit`, params)
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err.response)
            return err
        })
}
export const CalcPriceSnappShoptVariant = params => {
    return axios.post(`/v2/snappshop/variations/calc-price`, params)
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err.response)
            return err
        })
}
export const GetSnappShopErrorList = () => {
    return axios.get(`/v2/snappshop/variations/errors`)
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err.response)
            return err
        })
}
export const GetSnappShopGroupList = () => {
    return axios.get(`/v2/snappshop/variations/groupList`)
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err.response)
            return err
        })
}
export const GetSnappShopBrandList = () => {
    return axios.get(`/v2/snappshop/variations/brandList`)
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err.response)
            return err
        })
}
// ImportVariantFile & ProcessFile
export const ImportSnappShopVariantFile = (params, setProgress) => {
    return axios.post('/v2/snappshop/variations/upload', params, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: data => {
            let temp = (data.loaded / data.total) * 100;
            typeof temp !== "undefined" && setProgress((data.loaded / data.total) * 100)
        }
    })
        .then(res => {
            return res
        })
        .catch(err => {
            return err
        })
}
export const ProcessSnappShopFile = (params) => {
    return axios.post('/v2/snappshop/variations/import', params)
        .then(res => {
            return res
        })
        .catch(err => {
            return err
        })
}

//report**************************************************
export const CreateReports = (params) => {
    return axios.post('/v1/report/create', params)
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err.response)
        })
}
export const GetReportList = (params) => {
    return axios.get('v1/report/all', { params: { ...params } })
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err.response)
        })
}
export const DeleteReport = (params) => {
    return axios.post('v1/report/delete', params)
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err.response)
        })
}
export const GetShowReportList = (params) => {
    return axios.post('v1/report/generate', params)
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err.response)
        })
}
export const EditReport = (params) => {
    return axios.post('v1/report/edit', params)
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err.response)
        })

}
export const GetReportFilterRange = (params) => {
    return axios.post('v1/report/range', params)
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err.response)
        })

}
export const GenerateReportExcel = (params) => {
    return axios.post('v1/report/generateExcel', params)
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err.response)
        })
}

//proReports*****************************************
export const GetProReportList = (params) => {
    return axios.post('v1/proReport/list', params)
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err.response)
        })

}
export const GenerateProReport = (params) => {
    return axios.post('v1/proReport/generate', params)
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err.response)
        })
}

export const GetReportDetails = (params) => {
    return axios.post('/v1/detailReport/list', params)
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err.response)
        })
}
//dashboard******************************************
export const GetDashboard = (params) => {
    // console.log("hi");
    return axios.get('v1/dashboard/basic', { headers: { token: Cookies.get('token') } })
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err, "err")
        })

}

export const GetDashboardHeader = (params) => {
    // console.log("hi");
    return axios.get('v1/dashboard/basic/header', { headers: { token: Cookies.get('token') } })
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err, "err")
        })
}

export const GetDashboardOrder = (params) => {
    // console.log("hi");
    return axios.get('v1/dashboard/basic/order', { headers: { token: Cookies.get('token') } })
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err, "err")
        })
}

export const GetDashboardVariantDetails = (params) => {
    // console.log("hi");
    return axios.get('v1/dashboard/basic/variantDetails', { headers: { token: Cookies.get('token') } })
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err, "err")
        })
}
//Discount**********************************************
export const GetDiscountList = (params) => {
    return axios.get('v1/discount/show', { params: { ...params } })
        .then(res => {
            console.log('res', res);
            return res
        })
        .catch(err => {
            console.log(err, "err");
            return err
        })
}
//payment***********************************************
export const GetPackages = (params) => {
    return axios.get('v1/payment/packages')
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err, "err");
            return err
        })

}

export const CalculatePackagePrice = (params) => {
    return axios.post('v1/payment/calculatePackagePrice', params)
        .then(res => {
            console.log(res, "res");
            return res
        })
        .catch(err => {
            console.log(err.response, 'err');
            return err
        })
}
export const CreateTransaction = (params, openToast) => {
    return axios.post('v1/payment/createTransaction', params, { timeout: 30000 })
        .then(res => {
            return res
        })
        .catch(err => {
            openToast(err.response && err.response.data ? err.response.data.error : 'اتصال به درگاه پرداخت با اختلال مواجه شد')
            return err
        })
}
export const VerifyTransaction = (params) => {
    return axios.post('v1/payment/verify', params)
        .then(res => {
            console.log(res.data, "data");
            return res
        })
        .catch(err => {
            console.log(err.response.data, "err");
            return err
        })
}
//import variant data**************************************************
export const ImportVariantFile = (params, setProgress) => {
    return axios.post('v1/import&export/upload/doc', params, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: data => {
            let temp = (data.loaded / data.total) * 100;
            typeof temp !== "undefined" && setProgress((data.loaded / data.total) * 100)
        }
    })
        .then(res => {
            return res
        })
        .catch(err => {
            return err
        })
}

export const ProcessFile = (params) => {
    return axios.post('v1/import&export/importFile', params)
        .then(res => {
            return res
        })
        .catch(err => {
            return err
        })
}
export const GenerateFile = () => {
    return axios.post('v1/import&export/exportData')
        .then(res => {
            console.log(res);
            return res
        })
        .catch(err => console.log(err))
}
export const GenerateSnappShopFile = () => {
    return axios.post('v2/snappshop/variations/export')
        .then(res => {
            console.log(res);
            return res
        })
        .catch(err => console.log(err))
}
// ******************************* Log System ******************
export const getLogList = (data) => {
    return axios.get("v1/log/get", { params: { ...data } })
        .then(res => {
            return res
        })
        .catch(error => {
            console.log(error.response)
        })
}


// ************************** Wallet *******************
export const GetWalletDetails = (params) => {
    return axios.get('v1/wallet/getDetails', { params: { ...params } })
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err, "err");
            return err
        })
}

export const GetUserFactors = () => {
    return axios.get('v1/factors')
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err, "err");
            return err
        })
}

export const GetWalletSettings = (params) => {
    return axios.get('v1/wallet/setting', { params: { ...params } })
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err, "err");
            return err
        })
}

export const GetWalletInvoice = () => {
    return axios.get('v1/wallet/invoice')
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err, "err");
            return err
        })
}

export const CalculateTotalCost = (params) => {
    return axios.post('v1/amount-pricing', params)
        .then(res => {
            console.log(res);
            return res
        })
        .catch(err => console.log(err))
}

// ************************* Edit Time Range
export const EditPackage = (params, openToast) => {
    return axios.post('v1/package/edit', params, { timeout: 30000 })
        .then(res => {
            return res
        })
        .catch(err => {
            openToast(err.response && err.response.data ? err.response.data.error : 'تغییر بازه زمانی با اختلال مواجه شد')
            return err
        })
}

export const EditSinglePricingRange = (params, openToast) => {
    return axios.post('v1/variant/editPricingRange', params)
        .then(res => {
            return res
        })
        .catch(err => {
            openToast(err.response.data.error)
            return err
        })
}

// **************************** Cargo
export const CreateCargo = (params, openToast) => {
    return axios.post('v1/cargo/create', params, { timeout: 30000 })
        .then(res => {
            return res
        })
        .catch(err => {
            openToast(err.response && err.response.data ? err.response.data.error : 'ثبت تنظیمات با اختلال مواجه شد')
            return err
        })
}

export const GetCargoConfigs = () => {
    return axios.get('v1/cargo/Configlist')
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err, "err");
            return err
        })
}

export const EditCargo = (params, openToast) => {
    return axios.post('v1/cargo/edit', params, { timeout: 30000 })
        .then(res => {
            return res
        })
        .catch(err => {
            openToast(err.response && err.response.data ? err.response.data.error : 'ثبت تنظیمات با اختلال مواجه شد')
            return err
        })
}

export const DeleteCargo = (id) => {
    return axios.post('v1/cargo/delete', { idList: id })
        .then(res => {
            return res
        })
        .catch(err => {
            // openToast(err.response.data.error)
            return err
        })
}

export const GetCargoLogList = (params) => {
    return axios.post('v1/cargo/list', { query: { ...params } })
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err, "err");
            return err
        })
}

export const GetWarehouses = () => {
    return axios.get('v1/cargo/warehouseCode')
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err, "err");
            return err
        })
}

export const WarehouseData = (params) => {
    return axios.post(`v1/cargo/warehousesData`, params)
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err, "err");
            return err
        })
}

// *********** Comments Get
export const GetComments = (params) => {
    return axios.get(`v1/comment/get`, { params: { ...params } })
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err, "err");
            return err
        })
}
// *********** order list Get
export const GetOrderList = (params) => {
    return axios.get(`v1/ongoingOrder`, { params: { ...params } })
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err, "err");
            return err
        })
}
// ****************** Feature Voting System
export const ListOfRequest = (params) => {
    return axios.get(`v2/feature-voting/mytweets`, { params: { ...params } })
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err, "err");
            return err
        })
}

export const GetTweetsList = (params) => {
    return axios.get(`v2/feature-voting/tweets`, { params: { ...params } })
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err, "err");
            return err
        })
}

export const CreateRequest = (params) => {
    return axios.post(`v2/feature-voting/tweets`, params)
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err, "err");
            return err
        })
}

export const LikeRequest = (id) => {
    return axios.post(`v2/feature-voting/tweets/like`, { tweetId: id })
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err, "err");
            return err
        })
}

export const CommentOnRequest = (params) => {
    return axios.post(`v2/feature-voting/tweets/comments`, params)
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err, "err");
            return err
        })
}

export const GetCommentsOnRequest = (params) => {
    return axios.get(`v2/feature-voting/tweets/${params.id}/comments`, { params: { ...params } })
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err, "err");
            return err
        })
}

export const DeleteTweet = (id) => {
    return axios.delete(`v2/feature-voting/tweets/${id}`)
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err, "err");
            return err
        })
}

// ************* calc max price **********
export const CalculateMaxPrice = (params) => {
    return axios.post(`v1/leaf-cat-calc/calc`, params)
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err, "err");
            return err
        })
}

// ************* complete progressBar **********
export const CompleteProgressBar = (params) => {
    return axios.post(`v2/progressbar/progress`, params)
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err, "err");
            return err
        })
}

export const GetProgressBar = () => {
    return axios.get(`v2/progressbar/getprogress`)
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err, "err");
            return err
        })
}

// ********************** default setting ************************* 
export const GetChannelDefaultSetting = (params) => {
    return axios.get(`v1/product-defaults`, { params: { ...params } })
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err, "err");
            return err
        })
}

export const SetChannelDefaultSetting = (params) => {
    return axios.post(`v1/product-defaults`, params)
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err, "err");
            return err
        })
}
// ********************* digiKala Auth V3 *************************
export const GetDKRedirectURL = () => {
    return axios.get(`v2/dk-login-v3/redirect_to_dk`)
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err, "err");
            return err
        })
}

export const GetDKToken = (params) => {
    return axios.get(`v2/dk-login-v3/token`, { params: { ...params } })
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err, "err");
            return err
        })
}
// ********************* blackfriday *************************
export const GetBlackFridayYourList = (params) => {
    return axios.get(`v2/blackFriday/list/yours`, { params: { ...params } })
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err, "err");
            return err
        })
}

export const GetBlackFridayCategoryList = (params) => {
    return axios.get(`v2/blackFriday/list/category`, { params: { ...params } })
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err, "err");
            return err
        })
}

export const GetBlackFridayList = (params) => {
    return axios.get(`v2/blackFriday/list/all`, { params: { ...params } })
        .then(res => {
            return res
        })
        .catch(err => {
            console.log(err, "err");
            return err
        })
}